// extracted by mini-css-extract-plugin
export default {"container":"contractOffer_container__7W8FI","offercontainer":"contractOffer_offercontainer__Xb0fz"};